/* eslint-disable */

// enums
export enum PaymentStatus {
  PAID = 'PAID',
  UNPAID = 'UNPAID',
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  REFUNDED = 'REFUNDED',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED'
}

export enum FulfillmentStatus {
  FULFILLED = 'FULFILLED',
  UNFULFILLED = 'UNFULFILLED',
  PARTIALLY_FULFILLED = 'PARTIALLY_FULFILLED',
  PACKSLIP_UNPRINTED = 'PACKSLIP_UNPRINTED'
}

export enum PickAndPackStatus {
  PICK_NOT_STARTED = 'PICK_NOT_STARTED',
  PICK_LIST_CREATED = 'PICK_LIST_CREATED',
  ITEMS_NOT_FOUND = 'ITEMS_NOT_FOUND',
  PICKED = 'PICKED',
  EXCLUDED_FROM_PACKING = 'EXCLUDED_FROM_PACKING',
  PACKED = 'PACKED'
}

export type RawPickAndPackStatus =
  | 'PICK_NOT_STARTED'
  | 'PICK_LIST_CREATED'
  | 'ITEMS_NOT_FOUND'
  | 'PICKED'
  | 'EXCLUDED_FROM_PACKING'
  | 'PACKED'

export enum OrderStatus {
  ALL = '',
  OPEN = 'OPEN',
  ARCHIVED = 'ARCHIVED',
  CANCELLED = 'CANCELLED'
}

export enum OrderItemCount {
  ALL = '',
  SINGLE_ITEMS = 'SINGLE_ITEMS',
  MULTI_ITEMS = 'MULTI_ITEMS'
}

export enum TimeFrameDimension {
  ORDERED_AT = 'ordered_at',
  PAID_AT = 'paid_at',
  SHIP_BY_DATE = 'ship_by_date'
}

// Filters
export interface Filters {
  paymentStatusFilters: IPaymentStatusFilter
  fulfillmentStatusFilters: IFulfillmentStatusFilter
  orderStatusFilters: OrderStatusFilter
}

export interface IPaymentStatusFilter {
  PAID: boolean
  UNPAID: boolean
  PARTIALLY_PAID: boolean
  REFUNDED: boolean
  PARTIALLY_REFUNDED: boolean
}

export interface IFulfillmentStatusFilter {
  fulfilled: boolean
  unfulfilled: boolean
  partiallyFulfilled: boolean
  packslipPrinted: boolean
}

export interface OrderStatusFilter {
  open: boolean
  archived: boolean
  cancelled: boolean
}

export type PickAndPackFilter =
  | PickAndPackStatus.PICK_NOT_STARTED
  | PickAndPackStatus.PICK_LIST_CREATED
  | PickAndPackStatus.ITEMS_NOT_FOUND
  | PickAndPackStatus.PICKED
  | PickAndPackStatus.PACKED
  // Pseudo statuses accepted by the pick_and_pack_status filter.
  // PICK_LIST_ELIGIBLE := status == PICK_NOT_STARTED AND order is not locked
  | 'PICK_LIST_ELIGIBLE'
  // PICK_IN_PROGRESS := status == PICK_LIST_CREATED AND order still locked
  | 'PICK_IN_PROGRESS'

export interface IOrdersMetaState {
  categoryIds?: string // a CSV of category IDs
  // pickAndPackStatus = a CSV of PickAndPackFilter type
  pickAndPackStatus?: string
  marketIds?: string
  marketAccountIds?: string
  inventoryLocationIds?: string
  inventoryLocationNames?: string[]
  status?: OrderStatus
  paymentStatus?: string
  fulfillmentStatus?: string
  orderItemsCount?: OrderItemCount
  timeFrame?: Date[]
  timeFrameDimension?: TimeFrameDimension
  perPage: number
  shippingMethod?: string
  shippingDestination?: string
  includeOverdue?: string
  includeUrgent?: string
  page: number
  query?: string
  sort: string
  total?: number
  totalStatus?: string
  maxPages?: number
  resourceFilterId?: number | string
}

export interface IResourceFilter {
  id: number | string
  isDefault?: boolean
  title: string
  selected?: boolean
  resource?: string
  filters: IOrdersMetaState
  count?: number
}

export type onMetaChangeMultipleHandler = (
  changes: { key: string; value: any }[],
  resetPagination?: boolean,
  debounce?: boolean,
  refetch?: boolean
) => void

export type onMetaChangeHandler = (
  k: keyof IOrdersMetaState,
  value: any,
  resetPagination?: boolean,
  debounce?: boolean,
  refetch?: boolean
) => void
